import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { companyInfo } from '../data/mockData';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-section">
            <div className="footer-logo">
              <div className="logo-icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="8" cy="24" r="4" fill="#8FEC78"/>
                  <path d="M8 24L20 8L28 16" stroke="#4A90E2" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div>
                <div className="footer-brand">FULL-BIN</div>
                <div className="footer-tagline">{companyInfo.tagline}</div>
              </div>
            </div>
            <p className="footer-description">
              UK-based sustainability and IoT technology company. Smart solutions for energy optimization, environmental monitoring, and ESG compliance.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-heading">Solutions</h3>
            <ul className="footer-links">
              <li><Link to="/oh4">OH4 Energy System</Link></li>
              <li><Link to="/iot-sensors">Sensative IoT Sensors</Link></li>
              <li><Link to="/awaabs-law">Awaab's Law Compliance</Link></li>
              <li><Link to="/esg-support">ESG Support</Link></li>
              <li><Link to="/about">About Us</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h3 className="footer-heading">Contact</h3>
            <ul className="footer-contact">
              <li>
                <Mail size={16} />
                <a href={`mailto:${companyInfo.email}`}>{companyInfo.email}</a>
              </li>
              <li>
                <Phone size={16} />
                <a href={`tel:${companyInfo.phone}`}>{companyInfo.phone}</a>
              </li>
              <li>
                <MapPin size={16} />
                <span>London, United Kingdom</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
          </p>
          <p className="footer-company-number">
            Company No. 14949472 | Registered in England & Wales
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
